import util from '../util'

let controller = 'EnvioTitulo'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']), {
  ConsultaTitulo: function (linhaDigitavel, codigoBarras) {
    let paramns = { LinhaDigitavel: linhaDigitavel, CodigoBarras: codigoBarras }
    return util.Axios.Post(controller + '/ConsultaTitulo', paramns)
  }
})
